import { render } from "./VideoCards.vue?vue&type=template&id=b752cd9e&scoped=true"
import script from "./VideoCards.vue?vue&type=script&lang=js"
export * from "./VideoCards.vue?vue&type=script&lang=js"

import "./VideoCards.vue?vue&type=style&index=0&id=b752cd9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b752cd9e"]])

export default __exports__